import Vue from 'vue'
import Router from 'vue-router'
import store from './../store.js'
import Login from './../components/Home/Login.vue'
import Dashboard from './../components/Home/dashboard.vue'
import OTAgenda from './../components/Ordentrabajo/OTAgenda.vue'
import OTVencidas from './../components/Ordentrabajo/OTVencidas.vue'
import MisOT from './../components/Ordentrabajo/MisOT.vue'

import MisOTFechaentrega from './../components/Ordentrabajo/MisOTFechaentrega.vue'

import Wizardot1show from './../components/Ordentrabajo/Wizardot1show.vue'
import Wizardot2data from './../components/Ordentrabajo/Wizardot2data.vue'
import Wizardot3characteristics from './../components/Ordentrabajo/Wizardot3characteristics.vue'
import Wizardot4draw from './../components/Ordentrabajo/Wizardot4draw.vue'
import Wizardot4takephotos from './../components/Ordentrabajo/Wizardot4takephotos.vue'
import Wizardot5datadetail from './../components/Ordentrabajo/Wizardot5datadetail.vue'
import Wizardot6showprint from './../components/Ordentrabajo/Wizardot6showprint.vue'
import wizardot7printemail from './../components/Ordentrabajo/wizardot7printemail.vue'

import NewOT from './../components/Ordentrabajo/OTNueva.vue'

import Editvehiculo from './../components/Vehiculo/Editvehiculo.vue'
import Newvehiculo from './../components/Vehiculo/Editvehiculo.vue'

import Editcliente  from './../components/Cliente/Editcliente.vue'
import Newcliente from './../components/Cliente/Editcliente.vue'

import Drawing from './../components/Home/drawing.vue'

import ReciboConformidad from './../components/Ordentrabajo/ReciboConformidad.vue'
import ImagenesOT from './../components/Ordentrabajo/ImagenesOT.vue'

import BuscarOT from './../components/Ordentrabajo/BuscarOT.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: 'dashboard',
      component: Dashboard,
      meta: { 
        requiresAuth: true
      }
    },

//************************************************ */
    {
      path: '/OTAgenda',
      name: 'OTAgenda',
      component: OTAgenda,
      meta: { 
        requiresAuth: true
      }
    },
 
    {
      path: '/OTVencidas',
      name: 'OTVencidas',
      component: OTVencidas,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/MisOT',
      name: 'MisOT',
      component: MisOT,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/MisOTFechaentrega',
      name: 'MisOTFechaentrega',
      component: MisOTFechaentrega,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/wizardot1show',
      name: 'wizardot1show',
      component: Wizardot1show,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot2data',
      name: 'wizardot2data',
      component: Wizardot2data,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot3characteristics',
      name: 'wizardot3characteristics',
      component: Wizardot3characteristics,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot4draw',
      name: 'wizardot4draw',
      component: Wizardot4draw,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot4takephotos',
      name: 'wizardot4takephotos',
      component: Wizardot4takephotos,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot5datadetail',
      name: 'wizardot5datadetail',
      component: Wizardot5datadetail,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot6showprint',
      name: 'wizardot6showprint',
      component: Wizardot6showprint,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/wizardot7printemail',
      name: 'wizardot7printemail',
      component: wizardot7printemail,
      meta: { 
        requiresAuth: true
      }
    },
    
    {
      path: '/Editvehiculo',
      name: 'Editvehiculo',
      component: Editvehiculo,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Newvehiculo',
      name: 'Newvehiculo',
      component: Newvehiculo,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/Editcliente',
      name: 'Editcliente',
      component: Editcliente,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Newcliente',
      name: 'Newcliente',
      component: Newcliente,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/NewOT',
      name: 'NewOT',
      component: NewOT,
      meta: { 
        requiresAuth: true
      }
    },
//************************************************ */
    {
      path: '/drawing',
      name: 'drawing',
      component: Drawing,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/ReciboConformidad',
      name: 'ReciboConformidad',
      component: ReciboConformidad,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/ImagenesOT',
      name: 'ImagenesOT',
      component: ImagenesOT,
      meta: { 
        requiresAuth: true
      }
    },

    {
      path: '/BuscarOT',
      name: 'BuscarOT',
      component: BuscarOT,
      meta: { 
        requiresAuth: true
      }
    },

  ]
})

//Aquí verificar si tiene acceso a la funcion
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})

export default router